import React, { useState } from "react";
import "./issuers.css";
import { Header } from "../PageTemplate/Header";
import { Footer } from "../PageTemplate/Footer";

const IssuersPage = () => {
  const [isPlaying, setIsPlaying] = useState(false);

  const baseVideoSrc =
    "https://www.youtube.com/embed/p6oro5MYtHc?si=gHsx-qF2K5VrvG-U&mute=1&playsinline=1";

  const [videoSrc, setVideoSrc] = useState("");

  const startVideo = () => {
    if (isPlaying) return;
    setIsPlaying(true);

    if (!videoSrc) {
      setVideoSrc(
        baseVideoSrc + (baseVideoSrc.includes("?") ? "&autoplay=1" : "?autoplay=1")
      );
    } else if (!/autoplay=1/.test(videoSrc)) {
      setVideoSrc(
        videoSrc + (videoSrc.includes("?") ? "&autoplay=1" : "?autoplay=1")
      );
    }
  };

  const handleBannerClick = (e) => {
    if (isPlaying) return;
    const target = e.target;
    if (target.closest(".ie-cta")) return;
    startVideo();
  };

  return (
    <div className="vt-page-root">
      <Header />

      {/* HERO CARD */}
      <section className="vt-hero-wrap" aria-label="Hero: For Issuers">
        <div className="vt-hero-inner">
          <div className="vt-hero-card">
            <div className="vt-hero-bg">
              {/* <div className="vt-hero-bg-circle-1" />
              <div className="vt-hero-bg-circle-2" />
              <div className="vt-hero-bg-circle-3" />
              <div className="vt-hero-bg-circle-4" />
              <div className="vt-hero-bg-overlay" data-layout="Default" /> */}
            </div>

            <div className="vt-hero-content">
              <div className="vt-hero-pill">For Issuers</div>
              <div className="vt-hero-heading">
                <span>Set the </span>
                <span className="vt-hero-global">Global</span>
                <span> Standard</span>
              </div>
              <div className="vt-hero-text-block">
                <div className="vt-hero-desc">
                  Reduce administrative overhead and protect your institution’s
                  reputation. Issue secure credentials that place your graduates at
                  the front of the line
                </div>
                <div className="vt-hero-cta-row">
                  <div className="vt-hero-cta-issuer" data-property-1="Default">
                    <div className="vt-hero-cta-inner">
                      <div className="vt-hero-cta-text">
                        Become an Issuer Partner
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Illustration right */}
            <div className="vt-hero-illustration" aria-hidden="false">
              <img
                src="https://t-t-prod-c3atgyatcbgvfdhc.a02.azurefd.net/images/issuer.svg"
                alt="Issuer Illustration"
              />
            </div>
          </div>
        </div>
      </section>

      {/* MODERNISE YOUR LEGACY SECTION */}
      <section className="vt-legacy-section" role="region"
          aria-label="Modernise your legacy">
        <div className="vt-legacy-inner">
          <div className="vt-legacy-header">
            <div className="vt-legacy-title-row">
              <div className="vt-legacy-title">Modernise Your Legacy</div>
            </div>
            <div className="vt-legacy-description">
              Your institution’s reputation relies on the integrity of its credentials.
              VerifyTT eliminates the risk of credential fraud while automating the
              time-consuming process of manual verification responses.
            </div>
          </div>

          <div className="vt-legacy-cards-row" aria-label="Legacy benefits">
            <div className="vt-legacy-card vt-legacy-card--primary" aria-label="Brand protection">
              <div className="vt-legacy-card-header">
                <div className="vt-legacy-icon-wrap">
                  <div className="vt-legacy-icon"  aria-hidden="true">
                    <img
                      src="https://t-t-prod-c3atgyatcbgvfdhc.a02.azurefd.net/images/common_in_all.svg"
                      alt="Brand Protection"
                      className="vt-legacy-img-1"
                    />
                    <img
                      src="https://t-t-prod-c3atgyatcbgvfdhc.a02.azurefd.net/images/issuer_sec_1_1.svg"
                      alt="Brand Protection"
                      className="vt-legacy-img-2"
                    />
                  </div>
                </div>
                <div className="vt-legacy-card-title">Brand Protection</div>
              </div>
              <div className="vt-legacy-card-text">
                Cryptographically secured against forgery or alteration
              </div>
            </div>

            <div className="vt-legacy-card vt-legacy-card--primary" aria-label="Operational efficiency">
              <div className="vt-legacy-card-header">
                <div className="vt-legacy-icon-wrap">
                  <div className="vt-legacy-icon" aria-hidden="true">
                    <img
                      src="https://t-t-prod-c3atgyatcbgvfdhc.a02.azurefd.net/images/issuer_sec_1_2.svg"
                      alt="Operational Efficiency"
                      className="vt-legacy-img-1"
                    />
                    <img
                      src="https://t-t-prod-c3atgyatcbgvfdhc.a02.azurefd.net/images/OperationalEfficiency.svg"
                      alt="Brand Protection"
                      className="vt-legacy-img-2"
                    />
                  </div>
                </div>
                <div className="vt-legacy-card-title">Operational Efficiency</div>
              </div>
              <div className="vt-legacy-card-text">
                Issue thousands of credentials in a single click
              </div>
            </div>

            <div className="vt-legacy-card vt-legacy-card--primary" aria-label="Global mobility">
              <div className="vt-legacy-card-header">
                <div className="vt-legacy-icon-wrap">
                  <div className="vt-legacy-icon" aria-hidden="true">
                    <img
                      src="https://t-t-prod-c3atgyatcbgvfdhc.a02.azurefd.net/images/issuer_sec_1_3.svg"
                      alt="Global Mobility"
                      className="vt-legacy-img-1"
                    />
                    <img
                      src="https://t-t-prod-c3atgyatcbgvfdhc.a02.azurefd.net/images/GlobalMobility.svg"
                      alt="Global Mobility"
                      className="vt-legacy-img-2"
                    />
                  </div>
                </div>
                <div className="vt-legacy-card-title">Global Mobility</div>
              </div>
              <div className="vt-legacy-card-text">
                Equip your alumni with portable credentials recognised worldwide
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* HOW IT WORKS – FULL PAGE COVER */}
      <section className="hiw-section" role="region" aria-label="How it works">
        <div className="hiw-inner">
          <div className="hiw-left">
            <div className="hiw-heading">
              <div className="hiw-title">
                3-Step illustrative flow for Academic certificates
              </div>
              <div className="hiw-subtitle">
                Every step is engineered to protect your reputation and simplify your
                operations.
              </div>
            </div>

            <div className="hiw-illustration-card" aria-hidden="false">
              <div className="hiw-illustration-inner">
                <div className="hiw-illustration-media">
                  <img
                    src="https://t-t-prod-c3atgyatcbgvfdhc.a02.azurefd.net/images/issuer_sec_3_1.svg"
                    alt="How it works illustration"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="hiw-steps" aria-label="Steps">
            <div className="hiw-step" aria-label="Step 1: Connect">
              <div className="hiw-step-badge">
                <div className="hiw-step-number">01</div>
              </div>
              <div className="hiw-step-content" aria-hidden="true">
                <div className="hiw-step-title">Connect</div>
                <div className="hiw-step-text">
                  We integrate securely with your existing student record systems.
                </div>
              </div>
            </div>

            <div className="hiw-arrow-row" aria-label="Step 2: Issue">
              <div className="hiw-arrow-col">
                <div className="hiw-arrow" />
              </div>
              <div className="hiw-arrow-fill" />
            </div>

            <div className="hiw-step">
              <div className="hiw-step-badge">
                <div className="hiw-step-number">02</div>
              </div>
              <div className="hiw-step-content">
                <div className="hiw-step-title">Issue</div>
                <div className="hiw-step-text">
                  Generate and distribute digital certificates instantly to an entire
                  graduating cohort.
                </div>
              </div>
            </div>

            <div className="hiw-arrow-row" aria-hidden="true">
              <div className="hiw-arrow-col">
                <div className="hiw-arrow" />
              </div>
              <div className="hiw-arrow-fill" />
            </div>

            <div className="hiw-step" aria-label="Step 3: Verify" >
              <div className="hiw-step-badge">
                <div className="hiw-step-number">03</div>
              </div>
              <div className="hiw-step-content">
                <div className="hiw-step-title">Verify</div>
                <div className="hiw-step-text">
                  When employers check a graduate’s claim, the system confirms
                  automatically.
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ISSUANCE EXPERIENCE VIDEO BANNER */}
      {/* <section className="ie-section" role="region" aria-label="Issuance experience demo">
        <div
          className={`ie-banner ${isPlaying ? "is-playing" : ""}`}
          onClick={handleBannerClick}
        >
          <div className="ie-bg-wrapper">
            <div className="ie-bg-overlay" />
          </div>

          <div className="ie-video-bg">
            <iframe
              id="vtDemoVideo"
              src={videoSrc}
              data-src={baseVideoSrc}
              title="YouTube video player"
              frameBorder={0}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
              aria-label="VerifyTT demo video"
            />
          </div>

          <div className="ie-video-overlay" aria-hidden={isPlaying}/>

          <div className="ie-content">
            <div className="ie-heading-group">
              <div className="ie-eyebrow">The Issuance Experience</div>
              <div className="ie-subtitle">15-second demo</div>
            </div>

            <div
              className="ie-play-pill"
              onClick={(e) => {
                e.stopPropagation();
                startVideo();
              }}
              aria-label="Play 15-second demo"
            >
              <div className="ie-play-icon-wrapper">
                <div className="ie-play-icon-inner">
                  <img
                    src="https://t-t-prod-c3atgyatcbgvfdhc.a02.azurefd.net/images/Play.svg"
                    alt="play"
                    aria-hidden="true"
                  />
                </div>
              </div>
            </div>

            <div className="ie-cta" data-property-1="Default" aria-label="Become an Issuer Partner">
              <div className="ie-cta-inner">
                <div className="ie-cta-text">Become an Issuer Partner</div>
              </div>
            </div>
          </div>

          <div className="ie-height-spacer" />
        </div>
      </section> */}

      <Footer />
    </div>
  );
};

export default IssuersPage;
